<template>
    <v-overlay
      :value="loading"
      :absolute="absolute"
      :color="backgroundColor ? backgroundColor : 'black'"
      :opacity="opacity"
      class="rx-spinner-overlay"
    >
      <component
        :is="componentByType"
        v-bind="$attrs"
        :size="size"
        :spinnerColor="styles.spinnerColor"
        class="rx-spinner-box"
      ></component>
      <slot name="message">
        <div v-if="!hideMessage">
          <h2>{{ messageDefault }}</h2>
        </div>
      </slot>
    </v-overlay>
</template>
<script>
const SPINNER_TYPE = {
  CIRCLE1: () => import("@/redworks/components/base/spinners/Circle1.vue"),
  CIRCLE2: () => import("@/redworks/components/base/spinners/Circle2.vue"),
  CIRCLE3: () => import("@/redworks/components/base/spinners/Circle3.vue"),
  CIRCLE4: () => import("@/redworks/components/base/spinners/Circle4.vue"),
  //CIRCLE4: () => import("@/redworks/components/base/spinners/Circle4.vue"),
  CUBESHADOW: () =>
    import("@/redworks/components/base/spinners/CubeShadow.vue"),
  DOUBLEBOUNCE: () =>
    import("@/redworks/components/base/spinners/DoubleBounce.vue"),
};
export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
    },
    hideMessage: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: "5rem",
    },
    spinnerType: {
      type: String,
      default: "CUBESHADOW",
    },
    spinnerColor: {
      type: String,
    },
    backgroundColor: {
      type: String,
    },
    absolute: {
      type: Boolean,
      default: false,
    },
    opacity: {
      type: String,
      default: "0.4",
    },
  },
  computed: {
    styles() {
      return {
        width: this.size,
        height: this.size,
        spinnerColor: this.spinnerColor
          ? this.spinnerColor
          : this.$vuetify.theme.themes.light.primary,
      };
    },
    componentByType() {
      return SPINNER_TYPE[this.spinnerType];
    },
    messageDefault() {
      if(this.hideMessage) {
        return null;
      } else {
        return this.message ? this.message : this.$t("common.msg.loading");
      }
    }
  },
};
</script>

<style scoped>
.rx-spinner-overlay {
  text-align: -webkit-center;
}
</style>
